export const userRoles = [
  { priority: 1, name: "super.admin" },
  { priority: 2, name: "admin.organization" },
  { priority: 3, name: "admin.location" },
  { priority: 4, name: "user.organization" },
  { priority: 5, name: "user.location" },
  { priority: 6, name: "user.asset" },
  { priority: 7, name: "user.intervention" },
] as const;
